import React, { useState } from 'react';
import { s as styled } from './styled-112a8bd0.js';
import SwiperCore, { Thumbs } from 'swiper/core';
import { B as Button } from './Button-e9d67c06.js';
import { S as Swiper } from './Swiper-c51ffbff.js';
import { C as Container } from './Container-09523e03.js';
import { L as LazyImage } from './LazyImage-542aa7bc.js';

const Wrapper = styled.div(({ bgColor }) => `
  background-color: ${bgColor};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
`);
const Header = styled.div `
  display: flex;
  justify-content: flex-end;
  height: 36px;
  align-items: center;
  z-index: 3;
`;
const Footer = styled.div `
  margin: 1rem 0;
  z-index: 3;
  .swiper-slide {
    width: auto !important;
  }
  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }
`;
const StyledImage = styled(LazyImage) `
  position: initial;
  img {
    min-width: 100%;
    max-height: 100%;
  }
`;
const StyledSmallImage = styled(LazyImage) `
  background: #fff;
`;
const ImageWrapper = styled.div `
  background: transparent;
  border: 0;
`;
const StyledContainer = styled.div `
  height: calc(100vh - 130px);
  z-index: 4;
  width: 100%;
  > div,
  .swiper-container {
    height: 100%;
    width: 100%;
  }
  .swiper-wrapper {
    height: 100% !important;
    width: 100% !important;
  }
`;
const Thumbnail = styled.button `
  transition: 0.1s ease opacity;
  text-align: center;
  background-color: transparent;
  border: 0;
  width: 60px !important;
  &:hover {
    opacity: 0.6;
  }
`;
const ButtonClose = styled(Button) `
  align-self: flex-end;
`;
const Gallery = ({ images, activeImageIndex, onClose, bgColor = '#000', }) => {
    SwiperCore.use([Thumbs]);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    return (React.createElement(Wrapper, { bgColor: bgColor },
        React.createElement(Header, null, onClose && (React.createElement(ButtonClose, { onClick: onClose, link: true, icon: { name: 'close', size: 26 } }))),
        React.createElement(StyledContainer, null,
            React.createElement(Swiper, { thumbs: { swiper: thumbsSwiper }, initialSlide: activeImageIndex, hasNavigation: true, slidesPerView: 1, slidesPerGroup: 1 }, images.map((image) => (React.createElement(ImageWrapper, { key: image.imageUrl, className: "swiper-slide" },
                React.createElement(StyledImage, { contain: true, imageWidth: 1000, src: image.imageUrl, alt: image.caption })))))),
        !!images.length && (React.createElement(Footer, null,
            React.createElement(Container, null,
                React.createElement(Swiper, { className: "gallery-thumbs", onSwiper: setThumbsSwiper, watchSlidesVisibility: true, watchSlidesProgress: true, spaceBetween: 10 }, images.map((image, index) => (React.createElement(Thumbnail, { key: index },
                    React.createElement(StyledSmallImage, { src: image.thumbnailUrl || image.imageUrl, alt: image.caption, contain: true, width: 60, height: 60, imageWidth: 150, borderRadius: 4 }))))))))));
};

export { Gallery as G };
